export class DataCatalogGrantScope {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetName",
            "baseName": "datasetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "includeDescendants",
            "baseName": "includeDescendants",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "descendantsTagExpression",
            "baseName": "descendantsTagExpression",
            "type": "DataCatalogTagExpression",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogGrantScope.attributeTypeMap;
    }
    constructor() {
    }
}
